/** 本地预览开关：true 时不走接口，页面用假数据展示 */
export const USE_MOCK = true;

const mockImg = (label, color) =>
  `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="400" height="400"><rect fill="${color}" width="400" height="400"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#624C16" font-size="36" font-family="sans-serif">${label}</text></svg>`
  )}`;

export const MOCK_INIT = {
  owningGroup: 'mockGroup',
  collectionId: '1001',
  maxCount: 3,
  materialMode: 0,
  randomCount: 3,
  synthesizeInitVOS: [
    {collectionId: '101', collectionName: '材料1', requiredQuantity: 30, nftImage: mockImg('材料1', '#EDE4C8'), imageBg: mockImg('材料1', '#EDE4C8')},
    {collectionId: '102', collectionName: '材料2', requiredQuantity: 50, imageBg: mockImg('材料2', '#D8E4D0')},
    {collectionId: '103', collectionName: '材料3', requiredQuantity: 0, imageBg: mockImg('材料3', '#D6E0EE')},
    {collectionId: '104', collectionName: '材料4', requiredQuantity: 0, imageBg: mockImg('材料4', '#EBD6D6')},
  ],
};

export const getMockMaterialList = (collectionId, currentPage = 1, pageSize = 10) => {
  const slot = MOCK_INIT.synthesizeInitVOS.find((item) => String(item.collectionId) === String(collectionId));
  const name = slot?.collectionName || '材料';
  const img = slot?.imageBg || mockImg(name, '#EDEDED');
  const totalCount = 24;
  const start = (currentPage - 1) * pageSize;
  const list = Array.from({length: totalCount}).slice(start, start + pageSize).map((_, index) => ({
    nftNo: `${collectionId || '101'}${1000 + start + index}`,
    nftImageUrl: img,
    nftImage: img,
    imageBg: img,
    collectionId,
  }));
  return {list, totalCount};
};

export const MOCK_SUCCESS = {
  nftNo: '8888888',
  nftImage: mockImg('合成结果', '#F0D24F'),
  collectionName: '合成藏品',
};

export const MOCK_RECORDS = [
  {
    upgradeId: 1,
    afterNftNo: '8888888',
    afterName: 'xxxxx这是藏品名称',
    upgradeImg: mockImg('合成', '#F0D24F'),
    upgradeTime: '2025-03-13 12:00:00',
  },
  {
    upgradeId: 2,
    afterNftNo: '7777777',
    afterName: '春季限定合成藏品',
    upgradeImg: mockImg('春季', '#CEBF7D'),
    upgradeTime: '2023-04-22 18:30:00',
  },
  {
    upgradeId: 3,
    afterNftNo: '6666666',
    afterName: '数字藏品合成款',
    upgradeImg: mockImg('数字', '#E8D9A0'),
    upgradeTime: '2023-03-08 09:12:00',
  },
];
